import { Product } from "./product";

export enum ProductAction {
    SET_PRODUCTS = "[ProductAction] SET_PRODUCTS",
    SET_PRODUCT = "[ProductAction] SET_PRODUCT",
}
interface SetProducts {
    type: ProductAction.SET_PRODUCTS;
    products: Array<Product>;
}

interface SetProduct {
    type: ProductAction.SET_PRODUCT;
    product: Product;
}

export type ProductActionTypes = SetProducts | SetProduct;
